import { render, staticRenderFns } from "./LargeLabelsNew.vue?vue&type=template&id=2e3bd2f8&scoped=true"
import script from "./LargeLabelsNew.vue?vue&type=script&lang=js"
export * from "./LargeLabelsNew.vue?vue&type=script&lang=js"
import style0 from "./LargeLabelsNew.vue?vue&type=style&index=0&id=2e3bd2f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3bd2f8",
  null
  
)

export default component.exports